// src/utils/imageCropperHelper.js

/**
 * Given an image and a crop area, returns a new image file as a Blob.
 * This is a utility function used by the ImageCropperModal.
 * @param {string} imageSrc The source URL of the image.
 * @param {object} croppedAreaPixels The crop coordinates and size in pixels.
 * @returns {Promise<Blob>} A promise that resolves with the new cropped image Blob.
 */
export const getCroppedImage = (imageSrc, croppedAreaPixels) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const { x, y, width, height } = croppedAreaPixels;
      
      canvas.width = width;
      canvas.height = height;
      
      // Draw the cropped portion of the original image onto the new canvas
      ctx.drawImage(
        image,
        x,
        y,
        width,
        height,
        0,
        0,
        width,
        height
      );
      
      // Convert the canvas content to a Blob (a file-like object)
      canvas.toBlob(blob => {
        if (!blob) {
          reject(new Error('Canvas is empty'));
          return;
        }
        resolve(blob);
      }, 'image/jpeg'); // You can change 'image/jpeg' to 'image/png' if needed
    };
    image.onerror = (error) => {
      reject(error);
    };
    image.src = imageSrc;
  });
};